import { render, staticRenderFns } from "./ShopFloorTabe.vue?vue&type=template&id=4fdc5916&scoped=true&"
import script from "./ShopFloorTabe.vue?vue&type=script&lang=js&"
export * from "./ShopFloorTabe.vue?vue&type=script&lang=js&"
import style0 from "./ShopFloorTabe.vue?vue&type=style&index=0&id=4fdc5916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc5916",
  null
  
)

export default component.exports